<template>
  <div
    v-click-outside="handleClickOutSize"
    :style="{
      width: `${width}px`,
      'max-height': `${maxHeight}px`,
      left: `${warpperLeft}px`,
      top: `${wrapperTop}px`,
    }"
    class="wrapper-base-dropdown-rich"
  >
    <slot/>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  props: {
    width: {
      type: Number,
      default: 300,
    },
    offsetTop: {
      type: Number,
      default: 0,
    },
    offsetLeft: {
      type: Number,
      default: 0,
    },
    idRef: {
      type: String,
    },
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      partnerWidth: 0,
      partnerHeight: 0,
      partnerLeft: 0,
      partnerTop: 0,
      screenHeight: 0,
      renderedAt: Date.now(),
    }
  },

  computed: {
    warpperLeft() {
      return this.partnerLeft - this.width + this.partnerWidth + this.offsetLeft
    },
    wrapperTop() {
      return this.partnerTop + this.partnerHeight + this.offsetTop
    },
    maxHeight () {
      const marginBottom = 25
      return this.screenHeight - this.wrapperTop - marginBottom
    },
  },

  mounted() {
    this.setUI()

    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    setUI() {
      const partnerNode = document.getElementById(this.idRef)
      if (partnerNode) {
        const clientRect = partnerNode.getBoundingClientRect()
        this.partnerWidth = clientRect.width
        this.partnerHeight = clientRect.height
        this.partnerLeft = clientRect.left
        this.partnerTop = clientRect.top
        this.screenHeight = window.innerHeight
      }
    },
    handleResize() {
      this.setUI()
    },
    // fixed: this function called immediately right after component rendered. it will close this dropdown.
    // so need to ignore first time it call
    handleClickOutSize() {
      const diffTimeMs = Date.now() - this.renderedAt
      if (diffTimeMs > 100) {
        this.$emit('onClickOutside')
      }
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize, false)
  },
}
</script>

<style scoped>
.wrapper-base-dropdown-rich {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 5;
  overflow-y: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, .4);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDropdownRich.vue